import '../components/b2bB2cPopup/scripts';
import '../components/variantTable/scripts';